import script from "./WegowCheckbox.vue?vue&type=script&setup=true&lang=js"
export * from "./WegowCheckbox.vue?vue&type=script&setup=true&lang=js"

import "./WegowCheckbox.vue?vue&type=style&index=0&id=b39d21d6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b39d21d6"]])

export default __exports__